exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".maintenance-banner {\n  align-items: center;\n  background: #fff4d6;\n  border-bottom: 1px solid #e8c96a;\n  box-sizing: border-box;\n  color: #5d4700;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  justify-content: center;\n  line-height: 20px;\n  min-height: 40px;\n  padding: 8px 24px;\n  text-align: center; }\n\n.maintenance-banner__icon {\n  align-items: center;\n  border: 2px solid #8b6b00;\n  border-radius: 50%;\n  display: inline-flex;\n  flex: 0 0 auto;\n  font-size: 12px;\n  height: 17px;\n  justify-content: center;\n  margin-right: 9px;\n  width: 17px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/common/components/MaintenanceBanner/style.scss
// module id = 1023
// module chunks = 0